import React, {Component} from 'react'
import './DiscoveryButton.css';
import {Link } from 'gatsby';

export default class DiscoveryButton extends Component {


    render() {

        const styles = {
            backgroundImage: `linear-gradient(151deg, rgba(14, 153, 83, 0.8) 0%, rgba(2, 131, 66, 0.8) 100%), url(${this.props.image}) `
        }


        return (
            <Link className="button" to={this.props.link}>
                <div className="button-container" style={styles}>
            
                <h1 className="button-title">
                    {this.props.title}
                </h1>
            
                </div>
            </Link>
        )
    }
}

